/**
 * API Configuration
 * Centralized configuration for backend API endpoints
 */

// Base URL from environment variable or fallback
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://netto-db.bessacvps.fr';

/**
 * API Endpoints
 */
export const API_ENDPOINTS = {
  // Lists endpoints
  lists: `${API_BASE_URL}/api/lists`,
  list: (id: number) => `${API_BASE_URL}/api/lists/${id}`,
  
  // Items endpoints
  items: `${API_BASE_URL}/api/items`,
  item: (id: number) => `${API_BASE_URL}/api/items/${id}`,
  
  // Health check
  health: `${API_BASE_URL}/health`,
} as const;

/**
 * API Configuration options
 */
export const API_CONFIG = {
  timeout: 10000, // 10 seconds
  retries: 3,
  headers: {
    'Content-Type': 'application/json',
  },
} as const;
